import { makeStyles } from '@mui/styles'
import BoxAppBackgroundAnimationItem from './useBoxAppBackgroundAnimationItemStyle'
import times from 'lodash.times'
import { Hidden } from '@mui/material'

const useStyles = makeStyles(() => ({
  boxAppBackgroundAnimationGroup: {
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    zIndex: 0,
    pointerEvents: 'none',
  },
}))

const BoxAppBackgroundAnimation = () => (
  <Hidden smDown>
    <div className={useStyles().boxAppBackgroundAnimationGroup}>
      {times(6).map((key) => (
        <BoxAppBackgroundAnimationItem key={key} />
      ))}
    </div>
  </Hidden>
)

export default BoxAppBackgroundAnimation
